import { BookOpen, Check, X } from 'lucide-react'
import type { Subject } from '@/features/subjects/public'

type SubjectPickerModalProps = {
  subjects: Subject[]
  selectedId: number | null
  onClose: () => void
  onSelect: (subjectId: number) => void
}

export function SubjectPickerModal({ subjects, selectedId, onClose, onSelect }: SubjectPickerModalProps) {
  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-slate-950/45 p-4" role="presentation">
      <section className="w-full max-w-md overflow-hidden rounded-2xl bg-white shadow-2xl" role="dialog" aria-modal="true" aria-labelledby="subject-picker-title">
        <header className="flex items-center justify-between border-b border-slate-200 px-5 py-4">
          <h2 id="subject-picker-title" className="text-lg font-bold text-slate-900">Chọn môn học</h2>
          <button type="button" aria-label="Đóng" title="Đóng" onClick={onClose} className="rounded-lg p-1.5 text-slate-500 hover:bg-slate-100"><X size={20} /></button>
        </header>
        <div className="grid gap-2 p-4">
          {subjects.map(subject => {
            const selected = subject.id === selectedId
            return (
              <button
                key={subject.id}
                type="button"
                onClick={() => onSelect(subject.id)}
                className={`flex w-full items-center gap-3 rounded-xl border p-2.5 text-left transition ${selected ? 'border-sky-500 bg-sky-50' : 'border-slate-200 hover:border-sky-200 hover:bg-slate-50'}`}
              >
                <span className="grid h-12 w-12 shrink-0 place-items-center overflow-hidden rounded-xl bg-sky-50 text-sky-600">
                  {subject.icon ? <img src={subject.icon} alt="" className="h-full w-full object-cover" /> : <BookOpen size={20} />}
                </span>
                <span className="min-w-0 flex-1 truncate text-sm font-bold text-slate-800">{subject.name}</span>
                {selected && <Check size={18} className="shrink-0 text-sky-600" />}
              </button>
            )
          })}
        </div>
      </section>
    </div>
  )
}
